import React from "react"
export function Visa(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M14.333 2C15.253 2 16 2.746 16 3.667v12.666c0 .92-.746 1.667-1.667 1.667H5.667C4.747 18 4 17.254 4 16.333V3.667C4 2.747 4.746 2 5.667 2h8.666zM14 14H6v1.5h8V14zM10 4C7.794 4 6 5.794 6 8s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM8.235 8.524c.065.926.298 1.64.558 2.168a2.963 2.963 0 01-1.656-1.976l-.04-.192h1.138zm4.669 0a2.96 2.96 0 01-1.697 2.168c.231-.469.44-1.086.53-1.867l.028-.3h1.139zm-2.19 0c-.09 1.084-.442 1.779-.714 2.164-.25-.356-.57-.975-.688-1.92l-.026-.244h1.428zm.493-3.216a2.963 2.963 0 011.656 1.976l.04.192h-1.138l-.027-.301a5.655 5.655 0 00-.531-1.867zm-2.414 0a5.655 5.655 0 00-.53 1.867l-.028.3H7.096l.041-.19c.221-.884.84-1.61 1.656-1.977zM10 5.312c.25.356.57.975.688 1.92l.026.244H9.286l.026-.243c.117-.946.437-1.565.688-1.921z"
        fill="currentColor"
        id="prefix__visa"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
